import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import LayersIcon from '@mui/icons-material/Layers';
import type { PermissionGroup } from '../utils/groupPermissions';
import {
  CardTitle,
  GroupBadge,
  GroupBody,
  GroupCardContainer,
  GroupFooter,
  GroupHeader,
  GroupTitleWrap,
} from './style';

interface Props {
  group: PermissionGroup;
  onClick: () => void;
  manageLabel: string;
  activeCountLabel: (active: number, total: number) => string;
}

export const PermissionGroupCard = ({ group, onClick, manageLabel, activeCountLabel }: Props) => {
  const total = group.permissions.length;
  const active = group.permissions.filter(p => p.assigned).length;
  const allActive = active === total && total > 0;

  return (
    <GroupCardContainer type="button" onClick={onClick} aria-label={`${group.name} (${active}/${total})`}>
      <GroupHeader>
        <GroupTitleWrap>
          <LayersIcon sx={{ color: '#00AC47', fontSize: 20 }} />
          <CardTitle>{group.name}</CardTitle>
        </GroupTitleWrap>
        <GroupBadge allActive={allActive}>{`${active}/${total}`}</GroupBadge>
      </GroupHeader>
      <GroupBody>
        <span>{activeCountLabel(active, total)}</span>
        <GroupFooter>
          <span>{manageLabel}</span>
          <ChevronRightIcon />
        </GroupFooter>
      </GroupBody>
    </GroupCardContainer>
  );
};
